import React, { useState, useEffect, Fragment, useRef } from 'react';
import groupService from '../../../Group/services';
import service from '../service';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import { PageHeader } from '../../../../Common';
import Joi from '@hapi/joi';
import { validateProperty, validate } from "../../../Common";
import TextField from '@material-ui/core/TextField';
import FormHelperText from '@material-ui/core/FormHelperText';
import "react-datepicker/dist/react-datepicker.css";
import { AttendanceReportPluckingAndSundrySchema } from "../AttendanceReportPluckingAndSundrySchema";
import { LoadingSpinerComponent } from '../../../../Common/loader'
import { trackPromise } from 'react-promise-tracker';
import authService from '../../../Common/services';
import tokenService from '../../../../Common/tokenDecoder';
import CreatePdf from './createPdf';
import ReactToPrint from "react-to-print";
import '../../../Common/Table/table.css';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Card from '@material-ui/core/Card';
import _, { forEach } from 'lodash';
import { Container } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const screenCode = 'ATTENDANCEREPORTPLUCKINGANDSUNDRY';

const useStyles = makeStyles({
    table: {
        minWidth: 650,
    },
    dialog1: {
        width: 850,
    }
});

export function AttendanceReportPluckingAndSundry(props) {
    const classes = useStyles();
    const componentRef = useRef();

    const [groups, setGroups] = useState([]);
    const [operationEntity, setOperationEntity] = useState([]);
    const [collectionPoint, setCollectionPoint] = useState([]);
    const [tableData, setTableData] = useState([]);
    const [isTableHide, setIsTableHide] = useState(true);
    const [searchData, setsearchData] = useState({
        groupID: "",
        operationEntityID: "",
        collectionPointID: "",
        month: "",
        jobTypeID: "0"
    });
    const [employeeTypes, setEmployeeTypes] = useState([]);
    const [selectedSearchValues, setSelectedSearchValues] = useState({
        group: "",
        operationEntity: "",
        collectionPoint: "",
        month: "",
        jobTypeID: "0"
    });
    let arr2 = [];
    const [errors, setErrors] = useState({});
    const schema = Joi.object(AttendanceReportPluckingAndSundrySchema).options({ allowUnknown: true });
    const [data, setdata] = useState([]);
    const [total, setTotal] = useState([]);
    const DropdownChanges = Object.freeze({ "group": 1, "operationEntity": 2 })
    const [searchButtonHide, setSearchButtonHide] = useState(false);
    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false
    });
    const [dateArray, setDateArray] = useState([]);
    const [dataTotal, setDataTotal] = useState([]);

    useEffect(() => {
        trackPromise(
            getPermissions()
        )
    }, [])

    useEffect(() => {
        trackPromise(
            getOperationEntities()
        )
        resetDropDowns(DropdownChanges.group);
    }, [searchData.groupID])

    useEffect(() => {
        getCollectionPointsForDropDown();
        resetDropDowns(DropdownChanges.operationEntity);
    }, [searchData.operationEntityID])

    async function getEmployeeTypesForDropdown() {
        const result = await service.GetEmployeeTypesData();
        setEmployeeTypes(result);
    }

    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWATTENDANCEREPORTPLUCKINGANDSUNDRY');

        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');

        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');
        setPermissions({
            ...permissionList,

            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled: isOperationEntityFilterEnabled !== undefined
        });

        var token = tokenService.getUserDetailsFromToken();
        setsearchData({
            ...searchData,
            groupID: token.groupID,
            operationEntityID: token.operationEntityID
        });
        getGroupsForDropDown();
        getEmployeeTypesForDropdown();
    }

    function resetDropDowns(type) {
        if (type === DropdownChanges.operationEntity) {
            setsearchData({
                ...searchData,
                collectionPointID: "0",
            });
        } else if (type === DropdownChanges.group) {
            setsearchData({
                ...searchData,
                operationEntityID: "0",
                collectionPointID: "0"
            });
        }
    }

    async function getGroupsForDropDown() {
        const groupsList = await groupService.getGroupsForDropdown();
        setGroups(groupsList);
    }

    async function getOperationEntities() {
        const operationEntityList = await service.getOperationEntitiesByGroupForDropDown(searchData.groupID);
        setOperationEntity(operationEntityList);
    }

    async function getCollectionPointsForDropDown() {
        const collectionPoint = await service.getCollectionPointsByOperationentityGroupID(searchData.operationEntityID, searchData.groupID);
        setCollectionPoint(collectionPoint);
    }

    function handleChange(e) {
        e.preventDefault();
        const target = e.target;
        const value = target.value;
        const error = { ...errors };
        const errorMessage = validateProperty(target, AttendanceReportPluckingAndSundrySchema);
        errorMessage ? error[target.name] = errorMessage : delete error[target.name];

        setsearchData({
            ...searchData,
            [e.target.name]: value
        });
        setErrors(error);
        clearTableRelatedData();
    }

    function getNumDaysInMonth(dateStr) {
        const [year, month] = dateStr.split('-');
        const date = new Date(year, month + 1, 0);
        return date.getDate();
    }

    async function handleSearch(e) {
        e.preventDefault();
        const errorMessages = validate(schema, searchData);
        errorMessages !== null ? setErrors(errorMessages) : setErrors({});
        if (errorMessages)
            return;
        const result = await service.getReportData(searchData);
        setTableData(result);
        createDateArray();
        getSelectedDropdownValuesForReport(searchData);
        GetTotalHorizontallyForSundry(result);
    }

    function createDateArray() {
        const numDaysInMonth = getNumDaysInMonth(searchData.month);
        let dateArray = [];
        for (let i = 1; i <= numDaysInMonth; i++) {
            if (i < 10) {
                dateArray.push('0' + i);
            }
            else { dateArray.push(i); }
        }
        setDateArray([...dateArray]);
    }

    function getSelectedDropdownValuesForReport(searchForm) {
        setSelectedSearchValues({
            ...selectedSearchValues,
            group: groups[searchForm.groupID],
            operationEntity: operationEntity[searchForm.operationEntityID],
            collectionPoint: collectionPoint[searchForm.collectionPointID],
            month: searchForm.month,
            jobTypeID: searchForm.jobTypeID
        })
    }

    function generateDropDownMenu(data) {
        let items = []
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
            }
        }
        return items
    }

    function onCancelClick() {
        setsearchData({
            ...searchData,
            collectionPointID: "0",
        });

        clearTableRelatedData();
    }

    function clearTableRelatedData() {
        setdata([]);
        setIsTableHide(true);
        setSelectedSearchValues([]);
    }

    function GetTotalHorizontallyForSundry(result) {
        let newArray = [];
        let allTotal = 0;
        if (searchData.jobTypeID == 2) {
            result.forEach(item => {
                item.dataList.forEach(x => {
                    let newDate = x.readTime.slice(8, 10);
                    let item2 = newArray.find((y) => y.readTime === x.readTime.slice(8, 10));
                    if (item2) {
                        item2.readTime = newDate;
                        item2.total = item2.total + ((x.totalAmount >= x.configurationValue) ? 1 : 0.5);
                    } else {
                        newArray.push({
                            readTime: newDate,
                            total: (x.totalAmount >= x.configurationValue) ? 1 : 0.5
                        })
                    }
                })
            })
        }
        else {
            result.forEach(item => {
                item.dataList.forEach(x => {
                    let newDate = x.readTime.slice(8, 10);
                    let item2 = newArray.find((y) => y.readTime === x.readTime.slice(8, 10));
                    if (item2) {
                        item2.readTime = newDate;
                        item2.total = item2.total + ((x.totalAmount > 50 && x.totalAmount <= 100) ? 1 : 0.5);
                    } else {
                        newArray.push({
                            readTime: newDate,
                            total: (x.totalAmount > 50 && x.totalAmount <= 100) ? 1 : 0.5
                        })
                    }
                })
            })
        }
        var totalArray = _.cloneDeep(newArray)
        setTotal(newArray);

        totalArray.forEach(x => {
            allTotal = allTotal + x.total;
        });
        setDataTotal(allTotal);
    }

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="card">
                    <div className="card-body" id="startPoint">
                        <div className="row">
                            <PageHeader
                                title="Attendance Report Plucking & Sundry"
                                isButtonEnable={false}
                            />
                        </div>
                        <form>
                            <div className="form-group row">
                                <div className="col-md pb-1">
                                    <InputLabel shrink id="groupID">Group *</InputLabel>
                                    <Select
                                        fullWidth
                                        id="groupID"
                                        name="groupID"
                                        disabled={!permissionList.isGroupFilterEnabled}
                                        value={searchData.groupID}
                                        onChange={(e) => handleChange(e)}>
                                        <MenuItem value="0">--Select Group--</MenuItem>
                                        {generateDropDownMenu(groups)}
                                    </Select>
                                    {errors["groupID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["groupID"]}</FormHelperText>}
                                </div>
                                <div className="col-md pb-1">
                                    <InputLabel shrink id="operationEntityID">Operation Entity *</InputLabel>
                                    <Select
                                        fullWidth
                                        id="operationEntityID"
                                        name="operationEntityID"
                                        disabled={!permissionList.isOperationEntityFilterEnabled}
                                        value={searchData.operationEntityID}
                                        onChange={(e) => handleChange(e)}>
                                        <MenuItem value="0">--Select Operation Entity--</MenuItem>
                                        {generateDropDownMenu(operationEntity)}
                                    </Select>
                                    {errors["operationEntityID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["operationEntityID"]}</FormHelperText>}
                                </div>
                                <div className="col-md pb-1">
                                    <InputLabel shrink id="collectionPointID">Collection point *</InputLabel>
                                    <Select
                                        fullWidth
                                        id="collectionPointID"
                                        name="collectionPointID"
                                        value={searchData.collectionPointID}
                                        onChange={(e) => handleChange(e)}>
                                        <MenuItem value="0">--Select Collection point--</MenuItem>
                                        {generateDropDownMenu(collectionPoint)}
                                    </Select>
                                    {errors["collectionPointID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["collectionPointID"]}</FormHelperText>}
                                </div>
                            </div>
                            <div className="form-group row">
                                <div className="col-md pb-1">
                                    <InputLabel shrink id="jobTypeID">Job Type *</InputLabel>
                                    <Select
                                        id="jobTypeID"
                                        fullWidth
                                        name="jobTypeID"
                                        onChange={(e) => handleChange(e)}
                                        value={searchData.jobTypeID}>
                                        <MenuItem value="0">--Select Job Type--</MenuItem>
                                        <MenuItem value="1">Sundry</MenuItem>
                                        <MenuItem value="2">Plucking</MenuItem>
                                    </Select>
                                    {errors["jobTypeID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["jobTypeID"]}</FormHelperText>}
                                </div>
                                <div className="col-md pb-1">
                                    <InputLabel shrink id="searchDate">Month *</InputLabel>
                                    <TextField
                                        id="month"
                                        name="month"
                                        type="month"
                                        fullWidth
                                        onChange={(e) => handleChange(e)}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                    />
                                    {errors["month"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["month"]}</FormHelperText>}
                                </div>
                            </div>
                            <div className="form-group row">
                                <div className="col-md pb-1">
                                    <input
                                        disabled={validate(schema, searchData)}
                                        type="button"
                                        className="btn btn-primary"
                                        value="Generate"
                                        onClick={e => trackPromise(handleSearch(e))}
                                        hidden={searchButtonHide}
                                    />
                                    <input type="reset"
                                        className="btn btn-warning pull-right"
                                        value="Clear"
                                        onClick={onCancelClick}
                                    />
                                </div>
                            </div>
                        </form>
                        {tableData.length != 0 ?
                            <Container>
                                <Card style={{ justifycontent: 'center' }}>
                                    <Paper className={classes.paper}>
                                        <TableContainer>
                                            <Table aria-label="simple table">
                                                <TableHead>
                                                    <TableRow style={{ border: "2px solid black" }}>
                                                        <TableCell align="center" rowSpan={2} style={{ border: "2px solid black", fontWeight: "bold" }}>EMP No</TableCell>
                                                        <TableCell align="center" rowSpan={2} style={{ border: "2px solid black", fontWeight: "bold" }}>Name (First Name)</TableCell>
                                                        <TableCell align="center" colSpan={dateArray.length} style={{ border: "2px solid black", fontWeight: "bold" }}>Date</TableCell>
                                                        <TableCell align="center" rowSpan={2} style={{ border: "2px solid black", fontWeight: "bold" }}>Total</TableCell>
                                                    </TableRow>
                                                    <TableRow style={{ border: "2px solid black" }}>
                                                        {dateArray.map(x => {
                                                            return (
                                                                <TableCell key={x} align="center" style={{ border: "2px solid black", fontWeight: "bold" }}>{x}</TableCell>
                                                            )
                                                        })}
                                                    </TableRow>
                                                    <TableRow>
                                                    </TableRow>
                                                </TableHead>
                                                {searchData.jobTypeID == 2 ?
                                                    <TableBody>
                                                        {tableData.map(item => {
                                                            let totalhr = 0;
                                                            return (
                                                                <TableRow style={{ border: "2px solid black" }} key={item.date}>
                                                                    <>
                                                                        <TableCell align="center" style={{ border: "2px solid black", fontWeight: "bold" }}>{item.registrationNumber}</TableCell>
                                                                        <TableCell align="center" style={{ border: "2px solid black", fontWeight: "bold", }}>{item.firstName}</TableCell>
                                                                    </>
                                                                    {dateArray.map(x => {
                                                                        const res = item.dataList.filter(y => parseInt(y.readTime.slice(8, 10)) == parseInt(x))
                                                                        if (res.length > 0) {
                                                                            if (res[0].totalAmount >= res[0].configurationValue) {
                                                                                totalhr += 1;
                                                                            } else {
                                                                                totalhr += 0.5;
                                                                            }
                                                                        } return (
                                                                            <>
                                                                                {res.length > 0 ?
                                                                                    <TableCell align="center" style={{ border: "2px solid black", fontWeight: "bold" }} key={x.employeeID}>{res == undefined ? "-" :
                                                                                        res[0].totalAmount >= res[0].configurationValue ? 1 : 0.5}</TableCell>
                                                                                    :
                                                                                    <TableCell align="center" style={{ border: "2px solid black", fontWeight: "bold" }} key={x.employeeID}>{"-"}</TableCell>
                                                                                }
                                                                            </>
                                                                        )
                                                                    })
                                                                    }
                                                                    <TableCell align="center" style={{ border: "2px solid black", fontWeight: "bold" }}>{parseFloat(totalhr)}</TableCell>
                                                                </TableRow >
                                                            )
                                                        })}
                                                        <TableRow style={{ border: "2px solid black" }}>
                                                            <TableCell align="center" style={{ border: "2px solid black", fontWeight: "bold" }} colSpan={2}>Total</TableCell>
                                                            {dateArray.map(x => {
                                                                const res = total.find(y => parseInt(y.readTime) === parseInt(x))
                                                                return (
                                                                    <TableCell align="center" style={{ border: "2px solid black", fontWeight: "bold" }}>{res == undefined ? "-" : parseFloat(res.total).toFixed(1)}</TableCell>
                                                                )
                                                            })}
                                                            <TableCell align="center" style={{ border: "2px solid black", fontWeight: "bold" }} >{parseFloat(dataTotal).toFixed(1)}</TableCell>
                                                        </TableRow>
                                                    </TableBody> :
                                                    <TableBody>
                                                        {tableData.map(item => {
                                                            let totalhr = 0;
                                                            return (
                                                                <TableRow style={{ border: "2px solid black" }} key={item.date}>
                                                                    <>
                                                                        <TableCell align="center" style={{ border: "2px solid black", fontWeight: "bold" }}>{item.registrationNumber}</TableCell>
                                                                        <TableCell align="center" style={{ border: "2px solid black", fontWeight: "bold" }}>{item.firstName}</TableCell>
                                                                    </>
                                                                    {
                                                                        dateArray.map(x => {
                                                                            const res = item.dataList.filter(y => parseInt(y.readTime.slice(8, 10)) == parseInt(x))
                                                                            if (res.length > 0) {
                                                                                if (res[0].totalAmount > 50 && res[0].totalAmount <= 100) {
                                                                                    totalhr += 1;
                                                                                } else {
                                                                                    totalhr += 0.5;
                                                                                }
                                                                            }
                                                                            return (
                                                                                <>
                                                                                    {res.length > 0 ?
                                                                                        <TableCell align="center" style={{ border: "2px solid black", fontWeight: "bold" }} key={x.employeeID}>{res == undefined ? "-" :
                                                                                            (res[0].totalAmount > 50 && res[0].totalAmount <= 100) ? 1 : 0.5}</TableCell>
                                                                                        :
                                                                                        <TableCell align="center" style={{ border: "2px solid black", fontWeight: "bold" }} key={x.employeeID}>{"-"}</TableCell>
                                                                                    }
                                                                                </>
                                                                            )
                                                                        })
                                                                    }
                                                                    <TableCell align="center" style={{ border: "2px solid black", fontWeight: "bold" }}>{parseFloat(totalhr)}</TableCell>
                                                                </TableRow >
                                                            )
                                                        })}
                                                        <TableRow style={{ border: "2px solid black" }}>
                                                            <TableCell align="center" style={{ border: "2px solid black", fontWeight: "bold" }} colSpan={2}>Total</TableCell>
                                                            {dateArray.map(x => {
                                                                const res = total.find(y => parseInt(y.readTime) === parseInt(x))
                                                                return (
                                                                    <TableCell align="center" style={{ border: "2px solid black", fontWeight: "bold" }}>{res == undefined ? "-" : parseFloat(res.total).toFixed(1)}</TableCell>
                                                                )
                                                            })}
                                                            <TableCell align="center" style={{ border: "2px solid black", fontWeight: "bold" }} >{parseFloat(dataTotal).toFixed(1)}</TableCell>
                                                        </TableRow >
                                                    </TableBody>
                                                }
                                            </Table>
                                        </TableContainer>
                                    </Paper>
                                </Card>
                            </Container>
                            : null}
                    </div>
                    {
                        tableData.length > 0 ?
                            <div className="pt-2">
                                <ReactToPrint
                                    documentTitle={"Attendance Report Plucking & Sundry"}
                                    trigger={() => <input
                                        type="button"
                                        className="btn btn-primary pull-right ml-2"
                                        value="PDF"
                                    />}
                                    content={() => componentRef.current}
                                />
                                <div hidden={true}>
                                    <CreatePdf ref={componentRef} searchData={selectedSearchValues}
                                        data={tableData} total={total} hrTotal={dataTotal} dateArray={dateArray} />
                                </div>
                            </div>
                            : null
                    }
                </div >
            </div >
        </Fragment >
    );
}